import React from 'react';
import { MdSecurity, MdGavel } from 'react-icons/md';

function Challenges() {
  return (
    <div className="min-h-screen bg-gray-50 pt-24 pb-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <h1 className="text-3xl font-extrabold text-gray-900 sm:text-4xl flex items-center justify-center">
             <MdSecurity className="mr-3 text-red-600" />
            Challenges Faced By Media Reporters
          </h1>
          <p className="mt-4 text-xl text-gray-500">
            The ongoing struggle for truth and freedom.
          </p>
        </div>

        <div className="bg-white shadow-lg rounded-lg overflow-hidden mb-10">
             {/* Placeholder for a related image */}
            <div className="w-full h-64 bg-gray-200 flex items-center justify-center text-gray-500">
                <img 
                    src="https://images.unsplash.com/photo-1557992260-ec58e38d363c?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80" 
                    alt="Media Freedom" 
                    className="w-full h-full object-cover"
                />
            </div>
            
            <div className="p-8">
                <div className="text-gray-700 space-y-4 leading-relaxed text-justify">
                    <p>
                        There is no country without media journalist. But there is no dearth of riots here. We media journalists are still traveling towards freedom without any end.
                    </p>
                    <p>
                        Our goal is to tell the people about the dominating attitude of the politicians and their atrocities and the inhuman murders of the terrorists. The sad state is, if media journalists are fighting against this and bringing out the truth false cases are filed against them through cunningness.
                    </p>
                    <p>
                        The objective in attacking these people is to point out the political injustice and to whip social violations, to tell the world the atrocities of pretentious politicians and the brutal murders by terrorists. In these attacks many media journalists have lost their lives and their kith and kin.
                    </p>
                    <div className="my-6 p-4 border-l-4 border-red-500 bg-red-50 italic">
                        In such media and press world our brothers and sisters are still living having lost their things and stand alone. This will make us understand easily, the extent of freedom of press in India.
                    </div>
                    <p>
                        This is the reason why many media journalists are scared to tell the truth to the world. But not all are like that, even amidst these people many newspapers, media are still fighting.
                    </p>
                    <p>
                        Amidst politicians who have forgotten their ideologies, sages who act against the Vedas, preachers and clergy men, leaders who have forgotten personal discipline and many more fake intellectuals there are still some noble media journalists who are like rubies in the garbage. Politicians and anti-social elements day dream that these noble media journalists can be destroyed.
                    </p>
                </div>
            </div>
        </div>

        <div className="bg-white shadow-lg rounded-lg overflow-hidden">
            <div className="bg-blue-600 px-8 py-4">
                <h2 className="text-2xl font-bold text-white flex items-center">
                    <MdGavel className="mr-3" />
                    NAI Code of Ethics
                </h2>
            </div>
            <div className="p-8">
                <ul className="space-y-4">
                    {[
                        { title: "Principles of Reporting", link: "#" },
                        { title: "Research", link: "#" },
                        { title: "Freedom of the Press", link: "#" },
                        { title: "Independence of Reporting", link: "#" },
                        { title: "Code of Ethics", link: "#" },
                        { title: "Criteria & Rules and Regulations", link: "#" }
                    ].map((item, index) => (
                        <li key={index} className="flex items-center">
                            <span className="w-2 h-2 bg-blue-500 rounded-full mr-3"></span>
                            <a href={item.link} className="text-lg text-gray-700 hover:text-blue-600 hover:underline transition-colors">
                                {item.title}
                            </a>
                        </li>
                    ))}
                </ul>
            </div>
        </div>

      </div>
    </div>
  );
}

export default Challenges;
